import {Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {DNA} from "@dna/react";
import {RegistrationForm} from "./RegistrationForm";
import {useAsync} from "../common/async";
import {useEffect} from "react";
import {getLookups} from "../../services/medicationmanagement/userRegistration/userRegistraitionService";
import {RegistrationLookups} from "../../services/medicationmanagement/userRegistration/RegistrationLookups";
import {RenderIf} from "../common/render-if/RenderIf";

const useStyles = makeStyles({
    root:{
        width:"100%"
    },
    items:{
        display:"flex",
        flexDirection:"column",
        alignItems:"center",
    },
    rightSection:{        
        background: "radial-gradient(50% 50% at 50% 50%, #2AA4A2 0%, #025450 100%);",
        minHeight: "calc(100vh - 69.5px)",
        "& label":{
            color:"#FFFFFF",
            "&.title":{
                fontSize:"24px",
                fontWeight:600,
                lineHeight:"28px"
            },
            "&.subTitle":{
                fontSize: "16px",
                lineHeight: "24px",
                marginTop:"20px",
                marginBottom:"20px"
            }
        }
    },
    rightImage:{
        marginTop:"102px",
        height: "360px",
        width: "480px"
    }

});
export const RegisterUser=()=>{
    let classes = useStyles();
    let {inProgress,error,success,queryDispatcher} = useAsync();
    useEffect(()=>{
        queryDispatcher(getLookups());
    },[]);
    let lookUps:RegistrationLookups=success;
    return (<Grid container spacing={0} className={classes.root}>
        <Grid item xs={6} className={classes.items}>
            <RenderIf if={!!lookUps} else={<h4>...loading</h4>}>
                <RegistrationForm lookUps={lookUps}/>    
            </RenderIf>
            
        </Grid>
        <Grid item xs={6} className={`${classes.items} ${classes.rightSection}`}>
            <img className={classes.rightImage} src="https://customb2ccontentstorage.blob.core.windows.net/signin-ui-content/images/medpoint-placeholder-image.png"/>
            <label className="title">Simplify medication management in residential aged care.</label>
            
        </Grid>
    </Grid>);
}